import { PARTy } from '../../../auth/model/user.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import {
    UrlProviderService,
    EndPoints
} from 'src/app/service/urlprovider.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InputEmailService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    emailExists(emailAddress: string, party?: PARTy): Observable<any> {
        return this.post<any>(EndPoints.account_emailExists, false, '', {
            emailAddress: emailAddress,
            party: party
        });
    }

    checkEmailDomain(emailAddress: string): Observable<any> {
        return this.post<any>(EndPoints.account_checkEmailDomain, false, '', {
            emailAddress: emailAddress
        });
    }
}
